import React, { Component } from "react";
import PropTypes from "prop-types";
import SVGInputField from "../components/svgInputField";

import ContactStore from "../../stores/contactStore";
import ContactActions from "../../actions/contactActions";

export default class ContactForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			firstName: "",
			lastName: "",
			email: "",
			phone: "",
			subject: "",
			message: "",
			helper: "",
			formState: "",
			contactStore: ContactStore.getState()
		};
	}

	componentDidMount() {
		ContactStore.listen(this.contactStoreListen);
	}

	componentWillUnmount() {
		ContactStore.unlisten(this.contactStoreListen);
	}

	contactStoreListen = contactStore => {
		const { formState: oldFormState } = this.state;
		const { formState: newFormState } = contactStore;
		// console.log('conactStoreChange', oldFormState, newFormState);
		if (oldFormState !== newFormState) {
			//transition affects
			if (oldFormState === "working") {
				if (newFormState === "success") this.onSuccess();
				if (newFormState === "error") this.onFailure();
			}
		}

		this.setState({ contactStore, formState: contactStore.formState });
	};

	handleChange(event) {
		let obj = {};
		obj[event.target.name] = event.target.value;
		this.setState(obj);
	}

	handleInputChange(field, value) {
		let obj = {};
		obj[field] = value;
		this.setState(obj);
		// let obj = {};
		// const { newUser } = this.state;
		// obj[field] = value;
		//
		// this.setState(obj);
	}

	inputValidate(field) {
		let resp = "";
		if (field !== "") {
			resp = "populated";
		}
		return resp;
	}

	sendEmail = e => {
		e.preventDefault();
		let { firstName, lastName, email, phone, message } = this.state;

		let fullName = `${firstName} ${lastName}`;

		if (
			[firstName, lastName, email, phone, message].every(e => e.trim() !== "")
		) {
			ContactActions.sendEmail({ fullName, email, phone, message });
		} else {
			this.setHelper("Please ensure that you have filled in all fields.");
		}
	};

	formReset = () => {
		this.setState({
			firstName: "",
			lastName: "",
			email: "",
			phone: "",
			message: ""
		});
	};

	onSuccess = () => {
		this.setHelper("Thanks! Your message has been sent.");
		this.formReset();
	};

	onFailure = () => {
		this.setHelper(
			"Uh oh, something didn't work quite right, please try again."
		);
	};

	setHelper = helper => {
		this.setState({ helper }, () => {
			setTimeout(() => this.setState({ helper: "" }), 5000);
		});
	};

	render() {
		let {
			firstName,
			lastName,
			email,
			phone,
			subject,
			message,
			helper,
			contactStore: { formState }
		} = this.state;

		return (
			<form>
				<div className="row">
					<div className="col-12 col-md-6">
						<SVGInputField
							datatext="Enter your first name"
							placeholder="First Name"
							icon="light/user.svg"
							type="text"
							name="firstName"
							onChange={this.handleInputChange.bind(this)}
							inputValue={firstName}
						/>
					</div>
					<div className="col-12 col-md-6">
						<SVGInputField
							datatext="Enter your last name"
							placeholder="Last Name"
							icon="light/user.svg"
							type="text"
							name="lastName"
							onChange={this.handleInputChange.bind(this)}
							inputValue={lastName}
						/>
					</div>

					<div className="col-12 col-md-6">
						<SVGInputField
							datatext="Enter your mail id"
							placeholder="E-Mail Address"
							icon="light/at.svg"
							type="email"
							name="email"
							onChange={this.handleInputChange.bind(this)}
							inputValue={email}
						/>
					</div>
					<div className="col-12 col-md-6">
						<SVGInputField
							datatext="Enter your phone number"
							placeholder="Phone Number"
							icon="light/phone.svg"
							type="tel"
							name="phone"
							onChange={this.handleInputChange.bind(this)}
							inputValue={phone}
						/>
					</div>

					<div className="col-12 ">
						<SVGInputField
							datatext="Enter message"
							placeholder="Message"
							icon="light/pencil-alt.svg"
							type="text"
							name="message"
							onChange={this.handleInputChange.bind(this)}
							inputValue={message}
							controlWidth="full"
							textarea={true}
						/>
					</div>
				</div>
				{helper ? (
					<div className="col-12">
						<div className="alert alert-info p-3 mt-3 text-center">
							{helper}
						</div>
					</div>
				) : null}
				<button
					type="submit"
					className="btn btn-primary"
					onClick={this.sendEmail}
					disabled={formState === "working"}>
					Send Message
				</button>
			</form>
		);
	}
}
